import React from 'react';

const Progress = ({ label, value, width }) => {
  return (
       <>
      <div className='flex justify-between'>
        <div className="mb-1 text-sm font-normal text-[#505D6F]">{label}</div>
        <div className="mb-1 text-sm font-normal text-[#505D6F]">{value}</div>
      </div>
      
      <div className="w-full bg-royalPurple rounded-full h-[6px] mb-4">
        <div className="bg-purple h-[6px] rounded-full" style={{ width: width }}></div>
      </div>
      </>
   
  );
};

export default Progress;
